import { render, staticRenderFns } from "./type-text.vue?vue&type=template&id=c249486c&scoped=true&"
import script from "./type-text.vue?vue&type=script&lang=js&"
export * from "./type-text.vue?vue&type=script&lang=js&"
import style0 from "./type-text.vue?vue&type=style&index=0&id=c249486c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c249486c",
  null
  
)

export default component.exports